/**
 * This class handles taxonomy product category page funtionality.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

import Common from './common';

/**
 * Class ProductFilter
 */
export default class ProductFilter {

    /**
     * Cache dom elements for use in the class's methods
     *
     * @return {void}
     */
    cache() {

        this.$filters = $( '.js-products-filter' );
        this.FilterWrapperButton = $( '.product-filters__button' );
        this.FilterWrapperContainer = $( '.product-filters__nav' );
        this.DarkOverlay = $( '#js-dark-overlay-product-filters' );
        this.filterParents = $( '.product-filter' );
        this.loadMoreButton = $( '#js-infinite-scroll-btn' );
        this.openFiltersMenu = $( '#js-open-filters-menu' );
        this.removeActiveFilters = $( '#js-remove-active-filters' );
        this.postsWrapper = $( '#js-card-listing' );
        this.checkboxes = $( '.filter-checkbox' );
        this.filterTags = $( '.tag--filter-selection' );
        this.triggerFilteredQuery = this.triggerFilteredQuery.bind( this );
        this.scrollButton = document.getElementById( 'js-back-to-top' );
        this.closeFilterWrapper = $( '#js-close-product-filters-nav' );
        this.productFiltersNav = document.getElementById( 'js-product-filters-nav' );
        this.productFiltersNavWrapper = document.getElementById( 'js-product-filters-wrapper' );
        this.productFilterSearch = $( '#js-filters-by-search' );

        // Filter types.
        this.filterTypes = $( '.product-filter' ).map( ( idx, filter ) => {
            return filter.getAttribute( 'data-filter-type' );
        } );

        // Each filter selection content inside parent element.
        if ( this.filterParents.length ) {
            this.filterContent = Common.childrenFromEach( this.filterParents, '.product-filter__content' );
        }
    }

    /**
     * All common events.
     *
     * @return {void}
     */
    events() {

        const filtersContainer = $( '#js-product-filters' );

        // Bail early if filter does not exist.
        if ( ! filtersContainer.length ) {
            return;
        }

        const filtersContainerHeight = filtersContainer.height();
        const initTopPosition = filtersContainer.offset().top;
        const mainMenuHeight = $( '.site-masthead__container' ).height();
        const pageContentWidth = $( '.page-with-sidebar__content' ).width();
        const infiniteScrollContainer = $( '#js-infinite-scroll' );

        filtersContainer.css( {
            'width': pageContentWidth + 'px',
        } );

        $( window ).resize( () => {
            filtersContainer.css( {
                'width': ( $( '.page-with-sidebar__content' ).width() ) + 'px',
            } );
        } );

        // Handles sticky nav effect for product filters container.
        $( window ).scroll( () => {
            if ( $( window ).scrollTop() > initTopPosition && window.innerWidth > 840 ) {
                filtersContainer.addClass( 'sticky' );
                filtersContainer.css( {
                    'position': 'fixed',
                    'top': '115px',
                } );
                infiniteScrollContainer.css( {
                    'margin-top': ( 40 + mainMenuHeight + filtersContainerHeight ) + 'px',
                } );
            }
            else {
                filtersContainer.removeClass( 'sticky' );
                filtersContainer.css( {
                    'position': 'initial',
                    'top': '0',
                } );
                infiniteScrollContainer.css( {
                    'margin-top': '0',
                } );
            }
        } );

        // Close filters wrapper.
        this.closeFilterWrapper.on( 'click', () => {
            this.FilterWrapperButton.removeClass( 'filter--open' );
            this.FilterWrapperButton.attr( 'aria-expanded', false );
            this.FilterWrapperContainer.prop( 'hidden', true );
            this.DarkOverlay.addClass( 'hidden' );
        } );

        /**
         * When 'Remove all active filters' button is clicked.
         */
        this.removeActiveFilters.on( 'click', ( e ) => {

            // Hide 'remove all active filters' button.
            $( e.target ).removeClass( 'active' );

            $( '.filter--active' ).each( ( index, tag ) => {

                const tagId = tag.getAttribute( 'data-id' );
                const tagName = tag.getAttribute( 'data-name' );
                const checkbox = document.getElementById( tagId );
                const label = checkbox.parentNode.querySelector( 'label' );
                const filterType = tag.getAttribute( 'data-filter-type' );

                // Uncheck checkbox and remove active classes.
                checkbox.checked = false;
                label.classList.remove( 'tag--active' );
                tag.classList.remove( 'filter--active' );

                // Remove post wrapper's data-attributes.
                this.updateWrapperDataAttributes( 'data-' + filterType, tagName );

                // Remove all selected filters from URL.
                window.history.replaceState( null, null, window.location.pathname );
            } );

            this.checkboxes.each( ( index, checkbox ) => {
                $( '#' + checkbox.getAttribute( 'id' ) ).prop( 'disabled', false );
                $( '#' + checkbox.getAttribute( 'id' ) ).parent().css( { opacity: 1 } );
            } );

            // Scroll back to beginning of products section.
            if ( $( window ).scrollTop() > initTopPosition && window.innerWidth > 840 ) {
                window.scrollTo( {
                    top: initTopPosition - 150,
                    behavior: 'smooth',
                } );
            }

            // Trigger query to get all products from the term.
            this.triggerFilteredQuery();
        } );

        /**
         * Go through all checkboxes.
         */
        this.checkboxes.each( ( index, checkbox ) => {

            // If checkbox is clicked.
            $( checkbox ).on( 'click', ( e ) => {

                this.productFiltersNavWrapper.classList.add( 'is-loading' );

                // Clicked checkbox's ID.
                const checkboxId = e.target.id;

                // Clicked checkbox's data-name attr.
                const checkboxName = e.target.getAttribute( 'data-name' );

                // Ancestor element.
                const targetAncestor = e.target.parentNode.parentNode.parentNode;

                // Ancestor element's data-attribute.
                const ancestorDataAttr = 'data-' + targetAncestor.getAttribute( 'data-filter-type' );

                // Checkbox's label element.
                const label = e.target.parentNode.querySelector( 'label' );

                // This handles post wrapper's data-attribute updates.
                this.updateWrapperDataAttributes( ancestorDataAttr, checkboxName );

                // This updates query parameters to URL.
                this.updateUrl( targetAncestor );

                // Go through all filter tags.
                // eslint-disable-next-line
                this.filterTags.each( ( index, tag ) => {

                    if ( checkboxId === tag.getAttribute( 'data-id' ) ) {

                        if ( ! tag.classList.contains(
                            'filter--active' ) ) {
                            tag.classList.add( 'filter--active' );
                        }
                        else {
                            tag.classList.remove( 'filter--active' );
                        }
                    }
                } );

                // Check if label already has class 'tag--active'.
                if ( label.classList.contains( 'tag--active' ) ) {

                    // Remove active class from checkbox's label.
                    label.classList.remove( 'tag--active' );

                }
                else {

                    // Add active class to checkbox's label.
                    label.classList.add( 'tag--active' );
                }

                // Hide 'Remove all active filters' button if there's no selected filters.
                if ( window.location.href.includes( '?' ) ) {
                    this.removeActiveFilters.addClass( 'active' );
                }
                else {
                    this.removeActiveFilters.removeClass( 'active' );
                }

                // Scroll back to beginning of products section.
                if ( $( window ).scrollTop() > initTopPosition && window.innerWidth > 840 ) {
                    window.scrollTo( {
                        top: initTopPosition - 150,
                        behavior: 'smooth',
                    } );
                }

                // Trigger filtered query.
                this.triggerFilteredQuery();
            } );
        } );

        /**
         * Go through all filter tags.
         */
        this.filterTags.each( ( index, tag ) => {

            // If filter tag is clicked hide it and uncheck filter checkbox.
            $( tag ).on( 'click', () => {

                const tagId = tag.getAttribute( 'data-id' );
                const tagName = tag.getAttribute( 'data-name' );
                const filterType = tag.getAttribute( 'data-filter-type' );
                const checkbox = document.getElementById( tagId );
                const label = checkbox.parentNode.querySelector( 'label' );
                const targetAncestor = checkbox.parentNode.parentNode.parentNode;

                // Uncheck checkbox and remove active classes.
                checkbox.checked = false;
                label.classList.remove( 'tag--active' );
                tag.classList.remove( 'filter--active' );

                // This handles post wrapper's data-attribute updates.
                this.updateWrapperDataAttributes( 'data-' + filterType, tagName );

                // This updates query parameters to URL.
                this.updateUrl( targetAncestor );

                // Hide 'Remove all active filters' button if there's no selected filters.
                if ( window.location.href.includes( '?' ) ) {
                    this.removeActiveFilters.addClass( 'active' );
                }
                else {
                    this.removeActiveFilters.removeClass( 'active' );
                }

                // Scroll back to beginning of products section.
                if ( $( window ).scrollTop() > initTopPosition && window.innerWidth > 840 ) {
                    window.scrollTo( {
                        top: initTopPosition - 150,
                        behavior: 'smooth',
                    } );
                }

                // Trigger filtered query.
                this.triggerFilteredQuery();
            } );
        } );

        this.openFiltersMenu.on( 'click', () => {
            this.showFiltersOnDesktop();
        } );

        const debouncedSearch = this.Debounce( ( e ) => {
            this.productFiltersNavWrapper.classList.add( 'is-loading' );
            this.postsWrapper.attr( 'data-haku', e.target.value );
            this.updateUrl( e.target );
            this.triggerFilteredQuery();
        }, 1500 );

        this.productFilterSearch.on( 'input', debouncedSearch );
    }

    /**
     * Debounces a function to prevent it from being called too frequently.
     *
     * @param {Function} func The function to be debounced.
     * @param {number}   wait The time in milliseconds to wait before invoking the function.
     *
     * @return {Function} A debounced version of the input function.
     */
    Debounce( func, wait ) {
        let timeout;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout( timeout );
            timeout = setTimeout( () => {
                func.apply( context, args );
            }, wait );
        };
    }

    /**
     * Scroll back to the top of the page.
     *
     * @return {void}
     */
    backToTop() {
        // This is the amount in pixels that user needs to scroll before back to top-button appears
        const distanceFromTop = 500;

        // When the user scrolls down from the top of the document, show the button
        $( window ).scroll( () => {
            if ( document.body.scrollTop > distanceFromTop || document.documentElement.scrollTop > distanceFromTop ) {
                this.scrollButton.classList.remove( 'js-hidden' );
            }
            else {
                this.scrollButton.classList.add( 'js-hidden' );
            }
        } );

        // When the user clicks on the button, scroll to the top of the document
        this.scrollButton.onclick = function() {
            window.scrollTo( {
                top: 0,
                behavior: 'smooth',
            } );
        };

    }

    /**
     * Get query parameters from posts wrapper.
     *
     * @return {Object} Query parameters.
     */
    getQueryParameters() {

        const queryString = window.location.search;
        const urlSearchParams = new URLSearchParams( queryString );

        return Object.fromEntries( urlSearchParams.entries() );
    }

    /**
     * Trigger filttered query.
     *
     * @return {void}
     */
    triggerFilteredQuery() {

        let queryParameters = [];

        if ( window.location.href.includes( '?' ) ) {

            // Get active query parameters from the posts wrapper.
            queryParameters = this.getQueryParameters();

            // Remove empty query parameters.
            for ( const key in queryParameters ) {
                if ( queryParameters[ key ] === '' ) {
                    delete queryParameters[ key ];
                }
            }

            // We need the data like 'taxonomy: xxxx, value: xxxx'.
            queryParameters = Object.entries(
                queryParameters
            ).map( ( [ taxonomy, value ] ) => ( { taxonomy, value } ) );
        }

        // Assign this to thisClass to pass inside success.
        const thisClass = this;

        // Query AJAX request.
        dp( $( '#js-infinite-scroll' ).attr( 'data-model' ), {
            tidy: true,
            partial: 'product-card-list',
            args: {
                /*eslint-disable */
                query_parameters: queryParameters,
                /*eslint-enable */
            },
            success: ( data ) => {

                this.productFiltersNavWrapper.classList.remove( 'is-loading' );
                // If there's no results.
                if ( data.length === 0 ) {
                    thisClass.postsWrapper.html( '<li><p class="no-products no-products-text">Ei tuloksia.</p></li>' );
                }
                else {

                    // Replace whole DOM of the wrapping element.
                    thisClass.postsWrapper.html( data );

                    this.FiltersAvailability();

                }

                // Hide load more button.
                this.loadMoreButton.removeClass( 'active' );

            },
            error() {
                this.productFiltersNavWrapper.classList.remove( 'is-loading' );
                thisClass.postsWrapper.html( '<li><p class="no-products no-products-text">Virhe haussa.</p></li>' );
            },
        } );
    }

    /**
     * Active/de-active filter checkboxes based on availibility.
     *
     * @return {void}
     */
    FiltersAvailability() {
        const allItems = $( '[data-attributes]' );
        let attributesList = [];
        allItems.each( ( index, item ) => {
            const attributes = item.getAttribute( 'data-attributes' ).split( ' ' );
            attributesList = $.merge( attributesList, attributes );
        } );

        // Filter unique values.
        attributesList = attributesList.filter( function( value, index, array ) {
            return index === array.indexOf( value );
        } );

        this.checkboxes.each( ( index, checkbox ) => {
            if ( $.inArray( checkbox.getAttribute( 'id' ), attributesList ) === -1 ) {
                $( '#' + checkbox.getAttribute( 'id' ) ).prop( 'disabled', true );
                $( '#' + checkbox.getAttribute( 'id' ) ).parent().css( { opacity: 0.4 } );
            }
            else {
                $( '#' + checkbox.getAttribute( 'id' ) ).prop( 'disabled', false );
                $( '#' + checkbox.getAttribute( 'id' ) ).parent().css( { opacity: 1 } );
            }
        } );

        // Brand and color filters should be always available.
        $( '[id^="pa_tuotemerkki"]' ).prop( 'disabled', false );
        $( '[id^="pa_tuotemerkki"]' ).parent().css( { opacity: 1 } );
        $( '[id^="pa_vari"]' ).prop( 'disabled', false );
        $( '[id^="pa_vari"]' ).parent().css( { opacity: 1 } );

    }

    /**
     * Deal with product filter navigation.
     *
     * @return {void}
     */
    filterStuff() {

        // Toggle showing of whole filter navigation overlay
        this.FilterWrapperButton.on( 'click', () => {
            this.FilterWrapperButton.addClass( 'filter--open' );
            this.FilterWrapperButton.attr( 'aria-expanded', true );
            this.FilterWrapperContainer.prop( 'hidden', false );
            this.DarkOverlay.removeClass( 'hidden' );
        } );

        this.DarkOverlay.on( 'click', () => {
            this.FilterWrapperButton.removeClass( 'filter--open' );
            this.FilterWrapperButton.attr( 'aria-expanded', false );
            this.FilterWrapperContainer.prop( 'hidden', true );
            this.DarkOverlay.addClass( 'hidden' );
        } );

        /**
         * Go through all filter parent elements.
         */
        this.filterParents.each( ( index, filterParent ) => {

            // Toggle links.
            const filterLink = $( filterParent ).children( '.js-toggle-filter' );

            const filterContent = $( filterParent ).children( '.product-filter__content' );

            // Bind a click handler to each menu parent's link.
            filterLink.on( 'click', () => {

                // If if already open.
                if ( filterParent.classList.contains( 'product-filter--open' ) ) {

                    // Remove 'filter--open' class and set correct aria-labels etc.
                    filterParent.classList.remove( 'product-filter--open' );
                    filterLink.attr( 'aria-expanded', false );
                    filterContent.prop( 'hidden', true );

                }
                else {

                    // Add 'filter--open' class and set correct aria-labels etc.
                    filterParent.classList.add( 'product-filter--open' );
                    filterLink.attr( 'aria-expanded', true );
                    filterContent.prop( 'hidden', false );
                }
            } );
        } );
    }

    /**
     * Show filters on desktop.
     *
     * @return {void}
     */
    showFiltersOnDesktop() {
        if ( this.getWindowWidth() < 1280 ) {
            return;
        }

        // Each filter selection content inside parent element.
        this.filterParents.each( ( index, filterParent ) => {
            if ( ! $( filterParent ).hasClass( 'product-filter--open' ) ) {
                $( filterParent ).children( '.js-toggle-filter' ).click();
            }
        } );

        this.productFiltersNav.scrollIntoView( {
            behavior: 'smooth',
        } );

    }

    /**
     *  Get window width.
     *
     * @return {number} Client width.
     */
    getWindowWidth() {
        return document.documentElement.clientWidth;
    }

    /**
     * Set filters active if found on URL params.
     *
     * @return {void}
     */
    toggleActiveFilter() {

        // Get the filter value from url params.
        const filterValue = this.getUrlParameter( 'filter' );

        // If filter value found, remove active class from all filters and add it to current filter.
        if ( filterValue ) {
            this.$filters.removeClass( 'active' );

            this.$filters.each( ( index, value ) => {
                const filter = $( value );

                if ( filter.data( 'filter' ) === filterValue ) {
                    filter.addClass( 'active' );
                }
            } );
        }
    }

    /**
     * Get single url paramater.
     *
     * @see {@link https://davidwalsh.name/query-string-javascript}
     * @param {string} name Param name.
     * @return {string} Parameter.
     */
    getUrlParameter( name ) {
        name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
        const regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' );
        const results = regex.exec( location.search );

        return results === null ? '' : decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
    }

    /**
     * Update post wrapper's data-attributes according to selected filters.
     *
     * @param {string} attr Data attribute.
     * @param {string} term Term.
     * @return {void}
     */
    updateWrapperDataAttributes( attr, term ) {

        // Get requested data-attribute (attr) from post wrapper.
        const attribute = this.postsWrapper.attr( attr );

        // Create an array from data-attribute terms.
        let termArray = attribute.split( ',' );

        // Check if 'term' is already in termArray.
        if ( ! termArray.includes( term ) ) {

            // If is not in this array, add it.
            termArray.push( term );

        }
        else {

            // If term is in this array, remove it.
            termArray = termArray.filter( ( e ) => e !== term );
        }

        // Remove empty string elements from array.
        termArray = termArray.filter( ( e ) => e !== '' );

        // Update post wrapper's data-attributes.
        this.postsWrapper.attr( attr, termArray );
    }

    /**
     * Update URL according to selected filters.
     *
     * @param {string} targetAncestor ancestor's name.
     * @return {void}
     */
    updateUrl( targetAncestor ) {

        // Current URL.
        const currentUrl = window.location.href;

        // Ancestor element's data-attribute.
        const ancestorDataAttr = 'data-' + targetAncestor.getAttribute( 'data-filter-type' );

        // Atribute's value.
        let value = this.postsWrapper.attr( ancestorDataAttr );

        // Set value to null if it is an empty string.
        if ( value === '' ) {
            value = null;
        }

        const updatedUrl = this.updateQueryString(
            targetAncestor.getAttribute( 'data-filter-type' ), value, currentUrl
        );

        history.replaceState( '', '', updatedUrl );
    }

    /**
     * Update query string by key.
     *
     * @param {string} key   Query parameter key.
     * @param {string} value Query parameter value.
     * @param {string} url   Url to update.
     * @return {string} Modified URL.
     */
    updateQueryString( key, value, url ) {

        // If url wasn't setted use current location.
        if ( ! url ) {
            url = window.location.href;
        }

        const re = new RegExp( '([?&])' + key + '=.*?(&|#|$)(.*)', 'gi' );
        let hash;

        if ( re.test( url ) ) {

            if ( typeof value !== 'undefined' && value !== null ) {
                return url.replace( re, '$1' + key + '=' + value + '$2$3' );
            }
            hash = url.split( '#' );
            url = hash[ 0 ].replace( re, '$1$3' ).replace( /(&|\?)$/, '' );

            if ( typeof hash[ 1 ] !== 'undefined' && hash[ 1 ] !== null ) {
                url += '#' + hash[ 1 ];
            }

            return url;

        }
        if ( typeof value !== 'undefined' && value !== null ) {
            const separator = url.indexOf( '?' ) !== -1 ? '&' : '?';

            hash = url.split( '#' );
            url = hash[ 0 ] + separator + key + '=' + value;

            if ( typeof hash[ 1 ] !== 'undefined' && hash[ 1 ] !== null ) {
                url += '#' + hash[ 1 ];
            }

            return url;

        }
        return url;

    }

    /**
     * Get query parameter from URL.
     *
     * @param {string} sParam Parameter name.
     * @return {boolean|string} Qyery parameter name.
     */
    getQueryParameter( sParam ) {

        const sPageURL = decodeURIComponent( window.location.search.substring( 1 ) );
        const sURLVariables = sPageURL.split( '&' );
        let sParameterName;
        let i;

        for ( i = 0; i < sURLVariables.length; i++ ) {

            sParameterName = sURLVariables[ i ].split( '=' );

            if ( sParameterName[ 0 ] === sParam ) {
                return sParameterName[ 1 ] === undefined ? true : sParameterName[ 1 ];
            }
        }
    }

    /**
     * Update selected filters on page load.
     *
     * @param {string} filterType Filter type name.
     * @return {void}
     */
    updateFiltersOnPageLoad( filterType ) {

        let parameters = this.getQueryParameter( filterType );
        const checkboxes = $( '.filter-checkbox' );

        if ( parameters ) {

            parameters = parameters.split( ',' );

            this.postsWrapper.attr( 'data-' + filterType, parameters );

            // Go through all checkboxes.
            checkboxes.each( ( index, checkbox ) => {

                const dataName = checkbox.getAttribute( 'data-name' );
                const label = checkbox.parentNode.querySelector( 'label' );

                if ( parameters.includes( dataName ) ) {
                    checkbox.checked = true;
                    label.classList.add( 'tag--active' );
                }
            } );

            // Go through all filter tags.
            this.filterTags.each( ( index, tag ) => {

                const dataFilterType = tag.getAttribute( 'data-filter-type' );
                const dataName = tag.getAttribute( 'data-name' );

                if ( parameters.includes( dataName ) && dataFilterType === filterType ) {
                    tag.classList.add( 'filter--active' );
                }
            } );
        }
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {

        this.cache();
        this.events();
        this.toggleActiveFilter();
        this.filterStuff();
        this.backToTop();

        // Open filter only on desktop.
        if ( this.getWindowWidth() > 1280 ) {
            this.openFiltersMenu.click();
        }

        // Update filters status on page load.
        Array.from( this.filterTypes ).forEach( ( filterType ) => this.updateFiltersOnPageLoad( filterType ) );

        // Update search input and filters.
        this.productFilterSearch.val( this.getQueryParameter( 'haku' ) ? this.getQueryParameter( 'haku' ) : '' );
        this.FiltersAvailability();

        if ( window.location.href.includes( '?' ) ) {
            this.removeActiveFilters.addClass( 'active' );
        }
    }
}
